import { z } from "zod";

import { Codelist } from "@/data/codelists";

export const PayCodeTypeCode = z.union([
  z.literal("STANDARD_TIME"),
  z.literal("OVERTIME"),
  z.literal("ON_CALL"),
  z.literal("TRAVEL"),
  z.literal("PAID_TIME_OFF"),
  z.literal("LEAVE"),
  z.literal("OTHER"),
]);

export type PayCodeTypeCode = z.infer<typeof PayCodeTypeCode>;

export const PayCodeTypeCodelist = Codelist<PayCodeTypeCode>(PayCodeTypeCode);

export type PayCodeTypeCodelist = z.infer<typeof PayCodeTypeCodelist>;
